import React, { useCallback, useState } from "react";
import {
  Dialog,
  TextField,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@material-ui/core";
import { LoadingButton } from "@material-ui/lab";
import { empleadosApi } from "src/services/empleadosApi";
import { useSnackbar } from "src/components/snackbar";

export default function NuevaBitacora(props) {
  const { open, setOpen, empleado } = props;

  const [descripcionBitacora, setDescripcionBitacora] = useState("");
  const [agregarBitacoraEmpleado, { isLoading: agregandoBitacoraEmpleado }] =
    empleadosApi.useAddBitacoraEmpleadoMutation();
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeDescripcion = (event) => {
    setDescripcionBitacora(event.target.value);
  };

  const guardarDatos = useCallback(async () => {
    try {
      const body = {
        descripcion: String(descripcionBitacora).toUpperCase(),
        empleado: empleado.rut,
      };
      await agregarBitacoraEmpleado(body).unwrap();
      enqueueSnackbar("Bitácora agregada correctamente", {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
      setOpen(false);
    } catch (error) {
      enqueueSnackbar(
        error?.data?.message ||
          error.message ||
          "Ocurrió un error al agregar la bitácora",
        {
          variant: "error",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        },
      );
    }
  }, [
    agregarBitacoraEmpleado,
    descripcionBitacora,
    empleado?.rut,
    enqueueSnackbar,
    setOpen,
  ]);

  const cerrar = () => {
    handleClose();
  };

  return (
    <>
      <div>
        <Dialog open={open} fullWidth maxWidth="md">
          <DialogTitle id="form-dialog-title">Nueva Bitácora</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              value={descripcionBitacora}
              onChange={handleChangeDescripcion}
              required
              autoFocus
              multiline
              label="Descripción"
              fullWidth
              rows={10}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={cerrar}>Cerrar</Button>
            <LoadingButton
              loading={agregandoBitacoraEmpleado}
              onClick={guardarDatos}
              variant="contained"
            >
              Agregar
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}
